"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const sizeToScale = {
    0: 0.9,
    1: 0.7,
    2: 0.5,
    3: 0.3,
    4: 0.2,
};
const BUTTON_OFFSET = 70;
function SizesOptions({ cube, sizes, currentSize, active, className, onSelect, }) {
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, role: "dialog", "data-e2e": 'SizesOptions_Container', children: sizes.map((size, index) => {
            const offset = (index + 1) * BUTTON_OFFSET;
            return ((0, jsx_runtime_1.jsx)(ui_1.PushInAnimation, { delay: 200, "data-e2e": 'SizesOptions_PushInAnimation', children: (0, jsx_runtime_1.jsx)(Button, { cube: cube, size: sizeToScale[index], selected: size === currentSize, active: active, offset: offset, onClick: () => onSelect(size), "data-e2e": 'SizesOptions_Button' }) }, index));
        }) }));
}
exports.default = SizesOptions;
const Container = styled_components_1.default.div `
  display: flex;

  padding: 5px 0;

  overflow: hidden;
`;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: relative;

  width: 36px;
  height: 36px;

  margin: auto 30px auto 0;
  padding: 0;

  background-color: ${props => props.selected ? props.theme.screens.ratingBorder : 'none'};

  border-radius: ${props => (props.cube ? '0' : '50%')};

  transform: translateX(
    ${({ active, offset }) => (active ? '0' : `-${offset}px`)}
  );

  transition: transform 0.3s;

  &::after {
    position: absolute;
    top: 0;
    left: 0;

    box-sizing: border-box;

    border: 3px solid ${props => props.theme.white};

    ${props => props.cube
    ? (0, styled_components_1.css) `
            top: 5%;
            left: 5%;

            width: 90%;
            height: 90%;

            border-radius: 0;
          `
    : (0, styled_components_1.css) `
            width: 100%;
            height: 100%;

            border-radius: 50%;
          `};

    transform: scale(${props => props.size});

    content: ' ';
  }
`;
